// mix-blend-difference text-white
import { define } from 'wicked-elements'
import mezr from 'mezr'

define('[data-component~="interface-contrast"]', {
  init () {
    this.interfaces = [...document.querySelectorAll('[data-interface]')]
    this.triggers = [...document.querySelectorAll('[data-interface-trigger]')]
    this.checkIntersections = this.checkIntersections.bind(this)
  },
  connected () {
    this.checkIntersections()
    window.addEventListener('scroll', this.checkIntersections)
  },
  disconnected () {
    window.removeEventListener('scroll', this.checkIntersections)
  },
  checkIntersections () {
    this.interfaces.forEach(el => {
      let isIntersecting = this.triggers.some(trigger => {
        const intersection = mezr.intersection(trigger, el)
        return !!intersection && intersection?.height > el.clientHeight / 2
      })

      const intersectionClass = el.hasAttribute('data-interface-hide')
        ? 'is-obscured'
        : 'inverted'

      el.classList.toggle(intersectionClass, isIntersecting)
    })
  }
})
